<template>
  <div class="payBillManage">
    <!-- “payBill”限制css于本页面 -->
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @companyChange="companyChange"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :rowStyle="rowStyle"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token, billType: '2' }"
    ></sirui-upload>
  </div>
</template>
<script>
  // import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/capitalCenter/bill';
  import siruiUpload from '@/components/SiruiUpload';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'payBillManage',
    mixins: [tableMixins],
    components: {
      siruiUpload,
    },
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          /* {
            // 应付票据流水号
            name: this.$t('billList.column.payBillSerialNumber'),
            prop: 'billSerialNumber',
            type: 'input',
          }, */
          {
            // 公司
            name: this.$t('billList.column.billCompanyCode'),
            prop: 'billCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          /* {
            // 开票部门
            name: this.$t('billList.column.payBillTakeDepartmentNo'),
            prop: 'billTakeDepartmentNo',
            type: 'select',
            options: this.departmentList,
            filterable: true,
          },
          {
            // 应付票据号
            name: this.$t('billList.column.payBillCode'),
            prop: 'billCode',
            type: 'input',
          }, */
          {
            // 票据性质
            name: this.$t('billList.column.billProperty'),
            prop: 'billProperty',
            type: 'dict',
            dictType: 'bill_property',
          },
          {
            // 票据类型
            name: this.$t('billList.column.billCategory'),
            prop: 'billCategory',
            type: 'dict',
            dictType: 'bill_category',
          },
          {
            // 出票人
            name: this.$t('billList.column.payBillMakerName'),
            prop: 'billMakerName',
            type: 'input',
            maxlength: 20,
          },
          {
            // 票据状态
            name: this.$t('billList.column.billStatus'),
            prop: 'billStatus',
            type: 'dict',
            dictType: 'pay_bill_status',
          },
          {
            // 应付票据号
            name: this.$t('billList.column.payBillCode'),
            prop: 'billCode',
            type: 'input',
          },
          /* {
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('saleInvoice.accountingStatus'),
            dictType: 'post_status',
          },
          {
            // 到期日从
            name: '到期日从',
            prop: 'expiringDateBegin',
            type: 'startDaterangePicker',
          },
          {
            // 到期日到
            name: '到期日到',
            prop: 'expiringDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 出票日期从
            name: '出票日期从',
            prop: 'billMakeDateBegin',
            type: 'startDaterangePicker',
          },
          {
            // 出票日期到
            name: '出票日期到',
            prop: 'billMakeDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 录入日期从
            name: '录入日期从',
            prop: 'billRecordDateBegin',
            type: 'startDaterangePicker',
          },
          {
            // 录入日期到
            name: '录入日期到',
            prop: 'billRecordDateEnd',
            type: 'endDaterangePicker',
          },
          {
            // 录入人
            name: '录入人',
            prop: 'billRecorderNo',
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
          {
            prop: 'paymentVoucherNo',
            name: '解付凭证号',
            type: 'input',
            placeholder: this.$t('请输入解付凭证号'),
          }, */
        ];
      },
    },
    data() {
      return {
        footerTotalCols: { amount: ['billAmount'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        action: API.IMPORT_FUNDBILL,
        query: {
          billSerialNumber: null, // 应付票据流水号
          billCompanyCode: null, // 公司
          billTakeDepartmentNo: null, //开票部门
          billCode: null, // 应付票据号
          billProperty: null, // 票据性质
          billCategory: null, // 票据类型
          billMakerName: null, // 出票人
          billStatus: null, // 票据状态
          accountingStatus: null,
          expiringDateBegin: null, // 到期日从
          expiringDateEnd: null, // 到期日到
          billMakeDateBegin: null, // 出票日期从
          billMakeDateEnd: null, // 出票日期到
          billType: '2', // 票据分类
          searchOrderItems: [],
          billRecorderNo: null, //录入日期
          billRecordDateBegin: null, //录入日期
          billRecordDateEnd: null, //录入人
          voucherNo: null,
          paymentVoucherNo: null,
        },
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          // 应付票据流水号
          {
            field: 'billSerialNumber',
            title: 'billList.column.payBillSerialNumber',
            visible: true,
            width: 120,
          },
          // 公司
          {
            field: 'billCompanyName',
            title: 'billList.column.billCompanyCode',
            visible: true,
            width: 180,
          },
          // 应付票据号
          { field: 'billCode', title: 'billList.column.payBillCode', visible: true, width: 120 },
          // 票据性质
          {
            field: 'billProperty',
            title: 'billList.column.billProperty',
            visible: true,
            width: 120,
            dictType: 'bill_property',
          },
          // 票据类型
          {
            field: 'billCategory',
            title: 'billList.column.billCategory',
            visible: true,
            width: 120,
            dictType: 'bill_category',
          },
          // 出票日期
          {
            field: 'billMakeDate',
            title: 'billList.column.payBillMakeDate',
            visible: true,
            width: 120,
            sortable: true,
          },
          // 到期日
          {
            field: 'expiringDate',
            title: 'billList.column.expiringDate',
            visible: true,
            width: 120,
            sortable: true,
          },
          // 票据金额
          {
            field: 'billAmount',
            title: 'billList.column.billAmount',
            visible: true,
            width: 120,
            format: 'formatAmount',
          },
          // 票据状态
          {
            field: 'billStatus',
            title: 'billList.column.billStatus',
            visible: true,
            width: 120,
            dictType: 'pay_bill_status',
          },
          // 保证金金额
          /* {
            field: 'marginAmount',
            title: 'billList.column.marginAmount',
            visible: true,
            width: 120,
          },
          // 解付入账状态
          {
            field: 'paymentAccountingStatus',
            title: 'billList.column.paymentAccountingStatus',
            visible: true,
            width: 120,
            dictType: 'post_status',
          },
          // 解付凭证号
          { field: 'paymentVoucherNo', title: '解付凭证号', visible: true, width: 120 },
          // 保证金入账状态
          {
            field: 'accountingStatus',
            title: 'billList.column.accountingStatus',
            visible: true,
            width: 120,
            dictType: 'post_status',
          },
          // 凭证号
          { field: 'voucherNo', title: '凭证号', visible: true, width: 120 }, */
          // 收款人
          {
            field: 'billTakerName',
            title: 'billList.column.payBillTakerName',
            visible: true,
            width: 120,
          },
          // 收款人账号
          {
            field: 'billTakeBankAccount',
            title: 'billList.column.payBillTakeBankAccount',
            visible: true,
            width: 120,
          },
          // 收款人银行
          {
            field: 'billTakeBankName',
            title: 'billList.column.payBillTakeBankName',
            visible: true,
            width: 120,
          },
          // 出票人
          {
            field: 'billMakerName',
            title: 'billList.column.payBillMakerName',
            visible: true,
            width: 120,
          },
          // 出票人账号
          {
            field: 'billMakeBankAccount',
            title: 'billList.column.payBillMakeBankAccount',
            visible: true,
            width: 120,
          },
          // 出票人银行
          {
            field: 'billMakeBankName',
            title: 'billList.column.payBillMakeBankName',
            visible: true,
            width: 120,
          },
          // 承兑人
          {
            field: 'acceptorName',
            title: 'billList.column.acceptorName',
            visible: true,
            width: 120,
          },
          // 承兑人账号
          {
            field: 'acceptBankAccount',
            title: 'billList.column.acceptBankAccount',
            visible: true,
            width: 120,
          },
          // 承兑人银行
          {
            field: 'acceptBankName',
            title: 'billList.column.acceptBankName',
            visible: true,
            width: 120,
          },
          // 承兑人银行行号
          {
            field: 'acceptBankBranchNo',
            title: 'billList.column.acceptBankBranchNo',
            visible: true,
            width: 120,
          },
          // 能否转让
          /* {
            field: 'isAssignment',
            title: 'billList.column.isAssignment',
            visible: true,
            width: 120,
            dictType: 'yes-no',
          }, */
          // 录入人
          {
            field: 'billRecorderName',
            title: 'billList.column.billRecorderName',
            visible: true,
            width: 120,
          },
          // 录入日期
          {
            field: 'billRecordDate',
            title: 'billList.column.billRecordDate',
            visible: true,
            width: 120,
            sortable: true,
          },
        ],
        companyList: [],
        departmentList: [],
        pledgeList: [
          { value: '0', label: this.$t('billList.status.noPledge') },
          { value: '1', label: this.$t('billList.status.pledge') },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      //切换公司
      companyChange(val) {
        this.query.billTakeDepartmentNo = null;
        this.getDepartment(val.val);
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门 收票部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userInfo.userCode,
            userCode: this.userInfo.userInfo.userCode,
            personName: this.userInfo.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      // 获取列表数据
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageNum, pageSize };
        if (XEUtils.isArray(params.billRecorderNo) && params.billRecorderNo[0]) {
          params.billRecorderNo = params.billRecorderNo[0].id;
        }
        let res = await this.$axios.post(API.QUERY_FUNDBILL_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      // 排序
      sortChangeEvent({ property, order }) {
        this.query.searchOrderItems = [
          { column: property.replace(/([A-Z])/g, '_$1').toLowerCase(), asc: order == 'asc' },
        ];
        this.getData();
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = new Date();
        let expiringDate = new Date(row.expiringDate);
        let date = (expiringDate - newDate) / 1000 / 60 / 60 / 24;
        if (date <= 1 && row.billStatus == '01') {
          return {
            backgroundColor: 'rgb(254, 135, 131)',
          };
        }
      },
      // 按钮
      chooseClick(type) {
        this.multipleSelection = this.$refs.siruiTable.getCheckboxRecords();

        if (type == 'add' || type == 'edit') {
          if (type == 'edit' && this.multipleSelection.length != 1) {
            return this.tips('onlyOneSelectData', 'error');
          }
          if (type == 'edit' && this.multipleSelection[0].billStatus != '01') {
            return this.tips('onlyRegeist', 'error');
          }
          this.toPath(
            type == 'add' ? 'Add' : 'Edit',
            type == 'add' ? {} : { id: this.multipleSelection[0].id }
          );
        } else if (type == 'copy') {
          this.handleCopy();
        } else if (type === 'del' || type === 'cancel') {
          this.handleDel(type);
        } else if (type == 'import') {
          this.handleImport();
        } else if (type == 'export') {
          if (this.tableData.length === 0) {
            return this.tips('noExport', 'error');
          }
          this.handleExport();
        } else if (type === 'generateCredentials') {
          this.batchGenarateVoucher(
            'AE_AP_MARGIN_BILL',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSyncVoucher') {
          // 批量保证金入账
          this.batchSyncVoucher(
            API.BATCH_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSignSyncVoucher') {
          // 批量保证金标记入账
          this.batchSyncVoucher(
            API.BATCH_SIGN_VOUCHER,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type === 'generateCredentialsOffPay') {
          this.batchGenarateVoucher(
            'AE_AP_BILL',
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSyncOffPay') {
          // 批量解付入账
          this.batchSyncVoucher(
            API.BATCH_OFF_PAY,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        } else if (type == 'batchSignSyncOffPay') {
          // 批量解付标记入账
          this.batchSyncVoucher(
            API.BATCH_SIGN_OFF_PAY,
            { ids: this.multipleSelection.map((it) => it.id) },
            'ids'
          );
        }
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('Details', { id: value.row.id });
      },
      //批量上传
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // 导出
      handleExport() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = 'billType=2&';
          changeList.forEach((item) => {
            str += 'ids=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${API.EXPORT_FUNDBILL}?${str}access_token=${this.token.access_token}`;
        } else {
          const params = XEUtils.serialize(this.query);
          window.location.href = `${this.baseUrl}${API.EXPORT_FUNDBILL}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 删除/撤销弹框
      handleDel(type) {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let apiName = type == 'del' ? 'DEL_FUNDBILL' : 'CANCELYF_FUNDBILL';
        let canDelitems = [];
        this.multipleSelection.map((i) => {
          if (type == 'del' && i.billStatus == '01') {
            canDelitems.push(i);
          }
          if (type == 'cancel') {
            // 这边要等财务凭证做完
            canDelitems.push(i);
          }
        });
        if (canDelitems.length == 0) {
          return this.tips(type == 'del' ? 'noCanDelSelectData' : 'noCanCancelSelectData', 'error');
        }
        let items = canDelitems.map((i) => i.id);
        let message = '';
        if (canDelitems.length !== this.multipleSelection.length) {
          message =
            type == 'del'
              ? this.$t('billList.message.hasCannotDelTip')
              : this.$t('billList.message.hasCannotCancelTip');
        }
        this.$confirmAction(
          type == 'del' ? this.$t('confirm.delete') : this.$t('billList.message.cancel'),
          message
        )
          .then(() => {
            this.del(items, apiName);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      // 删除/撤销
      del(ids, apiName) {
        this.$axios.post(API[apiName], ids).then((res) => {
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.resetBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`billList.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(type, query) {
        let path = {
          path: `/capital/payBill${type}`,
          name: `payBill${type}`,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
